import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PedidosDetalhadosCard from './components/PedidosDetalhadosCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const PlanejamentoDetalhadoMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Planejamento Detalhado'
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <PedidosDetalhadosCard />
        </Col>
      </Row>
    </Container>;
};

export default PlanejamentoDetalhadoMain;
